import React, { ReactElement } from 'react'
import ErrorTemplate from '../templates/ErrorTemplate'
import { iconError } from '../../assets/images/images'

const Error404 = (): ReactElement => {
  return (
    <ErrorTemplate>
      <>
        <img src={iconError} alt="Problem Icon" />
        <div className="mt25">
          <h1 className="errorPageTitle">
            Attention <br />
            Une erreur est survenue !
          </h1>
          <p className="mt5 mb5 fontWeightBold fontSizeXs lh16">
            Veuillez nous excuser pour ce problème. Si cette erreur est
            bloquante ou persistante, veuillez noter le code et le statut de
            l&apos;erreur et contactez votre administrateur au{' '}
            <a href="mailto:support-kyc@webhelp.com" className="linkDefault">
              support-kyc@webhelp.com
            </a>
          </p>
        </div>
      </>
    </ErrorTemplate>
  )
}

export default Error404
